import blog1 from '../img/blogs/blog1.jpg'
import blog2 from '../img/blogs/blog2.jpg'
import blog3 from '../img/blogs/blog3.jpg'
import blog4 from '../img/blogs/blog4.jpg'

const blogs = [
    {
        id: 1,
        title: 'Coming Soon',
        date: '01',
        month: 'April',
        image: blog1,
        link: '#'
    },
    {
        id: 2,
        title: 'Coming Soon',
        date: '01',
        month: 'April',
        image: blog2,
        link: '#'

    },
    {
        id: 3,
        title: 'Coming Soon',
        date: '01',
        month: 'April',
        image: blog3,
        link: '#'

    },
    {
        id: 4,
        title: 'Coming Soon',
        date: '01',
        month: 'April',
        image: blog4,
        link: '#'

    }
]

export default blogs